/**
 * Copyright (C) 2025 Checkmk GmbH - License: GNU General Public License v2
 * This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
 * conditions defined in the file COPYING, which is part of this source code package.
 */

export enum Graph {
  SITE_OVERVIEW = 'site_overview',
  HOST_STATE = 'host_state',
  HOST_STATE_SUMMARY = 'host_state_summary',
  HOST_STATS = 'host_stats'
}
